import React, { Component } from 'react';
import {__} from './../Translator';

import './StepIndicator.css';

class StepIndicator extends Component {
  constructor(props) {
    super(props);

    /**
     * Object holding the steps and the screen names that should active that
     * step and the ones before.
     *
     * @type {{string: Array, ...}}
     */
    this.steps = {
      'Start': [],
      'Product': ['productSelection', 'modelSelection', 'modelPerforate'],
      'Design': ['modelColor', 'configurator', 'configured'],
      'Fit': ['modelFit'],
    };

    this.state = {
      currentScreen: props.currentScreen,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      currentScreen: nextProps.currentScreen,
    });
  }

  render() {
    return (
      <div className="stepIndicator">
        <ul>
          {Object.keys(this.steps).map(title => {
            return (
              <li key={title} className={'stepIndicator__step ' + (this.steps[title].indexOf(this.state.currentScreen) !== -1 ? 'is-active' : '')}>
                <span>{__(title)}</span>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default StepIndicator;



// WEBPACK FOOTER //
// ./src/components/StepIndicator.js